// Core
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Assets
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Button from 'components/commonComponents/Button';
import AlertSnackbar from 'components/commonComponents/AlertSnackbar';
import ActionLink from 'components/commonComponents/ActionLink';

// The shell of a small form modal: title, content, "Cancel" + loading "Submit", and the alert.
//   onClose(event, reason) is called for the backdrop/escape and onClose(false) for Cancel.
//   extra: anything that must live inside the dialog next to the form (e.g. a follow-up modal).
const FormDialog = ({ open, onClose, title, onSubmit, loading, alert, extra, children }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className='__common_model_class'
      maxWidth={'sm'}
      fullWidth={true}
      disableEscapeKeyDown
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        {children}
      </DialogContent>
      <DialogActions>
        <div className='d-flex align-items-center' style={{ margin: '15px' }}>
          <ActionLink onClick={() => onClose(false)} style={{ cursor: 'pointer', margin: '0 10px' }}>{t('cancel')}</ActionLink>
          <Button
            withLoader
            loading={loading}
            disabled={loading}
            handleOnClick={onSubmit}
            label={t('submit')}
          />
        </div>
      </DialogActions>
      <AlertSnackbar alert={alert} />
      {extra}
    </Dialog>
  );
};

export default FormDialog;

FormDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  alert: PropTypes.object,
  extra: PropTypes.node,
  children: PropTypes.node
};
